module.exports = __webpack_public_path__ + "faq/img/404.b4878b28.png";